<template>
    <v-card flat>
        <v-overlay v-if="loading" opacity="0.6" absolute>
            <v-progress-circular indeterminate color="secondary"></v-progress-circular>
        </v-overlay>
        <v-btn class="close-btn" @click="closeCopper" outlined icon>
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="page-title pa-2">
            {{ title }}
        </v-card-title>
        <v-card-text v-if="img" class="pa-2">
            <Cropper ref="cropper" :src="img" :stencil-props="{ handlers: {}, movable: false, resizable: false, }"
                :stencil-size="{ width: this.dimensions.width, height: this.dimensions.height }"
                image-restriction="stencil" @change="change" :style="style" :default-size="defaultSize"
                :min-height="limitations.minHeight" :min-width="limitations.minWidth"
                :canvas="{ maxWidth: limitations.maxWidth, }" />
        </v-card-text>
        <v-card-text v-else class="pa-2">
            <div style="width: 100%; margin-top: 5px; margin-bottom: 5px;" @click="openPictureSelectDialog">
                <v-overlay absolute v-if="profilePictureUploading">
                    Uploading Profile Picture
                    <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </v-overlay>
                <div
                    style="display: flex; justify-content: center; align-items: center; height: 300px; border: solid 1px black; border-radius: 5px; font-size: 20px; background-color: #F5F5F5; cursor: pointer;">
                    {{ videoOnly ? 'Choose Video' : allowVideo ? 'Choose Image Or Video' : 'Choose Image' }}
                </div>
            </div>
        </v-card-text>
        <v-row class="ma-0 pa-2 page-body" style="color: orange;">
            <v-alert outlined color="orange" class="pa-2 ma-0">
                Please drag and move the image to crop it.
            </v-alert>
        </v-row>
        <v-card-actions class="pa-2">
            <v-row class="ma-0" :justify="mobile ? 'space-around' : 'center'">
                <v-col class="pa-0" cols="auto">
                    <BrebBtn icon @click="zoom(1.2)" btnClass="mx-2">
                        <v-icon large>mdi-magnify-plus-outline</v-icon>
                    </BrebBtn>
                </v-col>
                <v-col class="pa-0" cols="auto">
                    <BrebBtn icon @click="zoom(0.8333)" btnClass="mx-2">
                        <v-icon large>mdi-magnify-minus-outline</v-icon>
                    </BrebBtn>
                </v-col>
                <!-- <BrebBtn icon @click="flip(true, false)" btnClass="mx-2">
                        <v-icon large>mdi-flip-horizontal</v-icon>
                    </BrebBtn>
                    <BrebBtn icon @click="flip(false, true)" btnClass="mx-2">
                        <v-icon large>mdi-flip-vertical</v-icon>
                    </BrebBtn> -->
                <!-- <BrebBtn @click="zoom(0.6667)">zoom out</BrebBtn> -->
                <v-col class="pa-0" cols="auto">
                    <BrebBtn icon @click="rotate(-90)" btnClass="mx-2">
                        <v-icon large>mdi-file-rotate-left-outline</v-icon>
                    </BrebBtn>
                </v-col>
                <v-col class="pa-0" cols="auto">
                    <BrebBtn icon @click="rotate(90)" btnClass="mx-2">
                        <v-icon large>mdi-file-rotate-right-outline</v-icon>
                    </BrebBtn>
                </v-col>
            </v-row>
        </v-card-actions>
        <v-card-actions class="pa-2">
            <v-row class="ma-0 mb-8" justify="center" align="center">
                <v-col class="pa-0" :cols="mobile ? 12 : 'auto'">
                    <BrebBtn v-if="img || selectedFile" backgroundColor="green" @click="uploadFile" btnClass="mr-2">
                        Upload
                    </BrebBtn>
                </v-col>
                <v-col v-if="!lisitngImage" class="pa-2" :cols="mobile ? 12 : 'auto'">
                    <label class="custom-file-input px-3" style="width: 100%" @click="openPictureSelectDialog">
                        {{ videoOnly ? 'Choose Video' : allowVideo ? 'Choose Image Or Video' : img ?
                            'Choose Other Image' : 'Choose Image' }}
                    </label>
                </v-col>
                <!-- <input id="file-input" type="file" accept="image/*" capture="environment" @change="onFileChange" /> -->
                <v-file-input v-if="!lisitngImage" :accept="accept" id="file-input" style="display: none;"
                    ref="fileSelect" @change="onFileChange" />
            </v-row>
        </v-card-actions>
        <BrebDialog title="Exceed Storage Limitation" :content="getLimitationContent" buttonContent="Subscribe a Plan"
            :buttonFunction="goPlanSubscription" :isDialogShown="showLimitationDialog" secondButtonContent="Cancel"
            :secondButtonFunction="cancelGoPlanSubscription" />
    </v-card>
</template>

<script>
import BrebBtn from "@/components/accessory/BrebBtn.vue";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import BrebDialog from '@/components/accessory/BrebDialog.vue';
import convert from 'heic-convert/browser';

export default {
    name: "BrebCropper",
    components: {
        BrebBtn,
        Cropper,
        BrebDialog,
    },
    mixins: [],
    props: {
        title: {
            type: String,
            default: "Upload an Image"
        },
        uploadType: {
            type: String,
            default: '',
        },
        stencilCoordinates: {
            type: Object,
        },
        lisitngImage: {
            default: null,
        },
        allowVideo: {
            type: Boolean,
            default: false,
        },
        videoOnly: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            loading: false,
            img: null,
            newFileName: null,
            selectedFile: null,
            limitations: {
                minWidth: 100,
                minHeight: 120,
                maxWidth: 1280,
                // maxHeight: 1536,
            },
            originalFileName: null,
            profilePictureUploading: false,
            showLimitationDialog: false,
            allowedImageTypes: ['image/', 'video/'],
            allowedImageExtensions: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif'],
        }
    },
    computed: {
        mobile() {
            return this.$vuetify.breakpoint.mobile
        },
        cellphone() {
            return this.$vuetify.breakpoint.xs
        },
        style() {
            return {
                width: `100%`,
                height: `300px`,
                transform: `translate(${0}px, ${0}px)`,
            };
        },
        ratio() {
            if (this.uploadType === 'portrait') {
                return {
                    width: 3,
                    height: 4,
                }
            } else if (this.uploadType === 'logo') {
                return {
                    width: 3,
                    height: 2,
                }
            } else if (this.uploadType === 'photo') {
                return {
                    width: 1,
                    height: 1,
                }
            } else if (this.uploadType === 'image') {
                return {
                    width: 4,
                    height: 3,
                }
            } else if (this.uploadType === 'homepageSlider') {
                return {
                    width: 2,
                    height: 1,
                }
            } else {
                return {
                    width: 16,
                    height: 9,
                }
            }
        },
        dimensions() {
            if (this.uploadType === 'portrait') {
                return {
                    width: this.ratio.width * (this.mobile ? 60 : 60),
                    height: this.ratio.height * (this.mobile ? 60 : 60),
                }
            } else if (this.uploadType === 'logo') {
                return {
                    width: this.ratio.width * (this.mobile ? 80 : 120),
                    height: this.ratio.height * (this.mobile ? 80 : 120),
                }
            } else if (this.uploadType === 'photo') {
                return {
                    width: this.ratio.width * (this.mobile ? 200 : 200),
                    height: this.ratio.height * (this.mobile ? 200 : 200),
                }
            } else if (this.uploadType === 'image') {
                return {
                    width: this.ratio.width * (this.mobile ? 60 : 80),
                    height: this.ratio.height * (this.mobile ? 60 : 80),
                }
            } else if (this.uploadType === 'homepageSlider') {
                return {
                    width: this.ratio.width * (this.mobile ? 150 : 200),
                    height: this.ratio.height * (this.mobile ? 150 : 200),
                }
            } else {
                return {
                    width: this.ratio.width * (this.mobile ? 20 : 25),
                    height: this.ratio.height * (this.mobile ? 20 : 25),
                }
            }
        },
        accept() {
            return this.videoOnly ? 'video/*' : this.allowVideo ? 'image/*,video/*' : 'image/*';
        },
        myPlan() {
            return this.$store.getters['api/plan/getMyPlan'];
        },
        isAdministratorGroup() {
            return this.$helpers.isAdministratorGroup(this.$store);
        },
        storageStats() {
            return this.$store.getters["api/file/getStats"];
        },
        hasVideoPermission() {
            return true;
			// return this.myPlan?.storage.allowed_video_quality !== "ALLOW_NONE" || this.isPostMerchant;
        },
        getLimitationContent() {
            return `You had reached the maximun storage limitation.<br/> Please subscribe a plan to get more storage.`;
        },
        user() {
            return this.$store.getters['user/getUser'];
        },
        isAppliedMerchant() {
            return this.user?.merchantApplication;
        },
        hasCityCreate() {
            return this.$helpers.hasCityCreate(this.$store);
        },
		isPostMerchant() {
			return this.$route.query?.postMerchant === 'true';
		},
    },
    watch: {

    },
    methods: {
        change({ coordinates, canvas }) {
            // console.log("++++++", coordinates, canvas)
        },
        defaultSize({ imageSize, visibleArea }) {
            return {
                width: (visibleArea || imageSize).width - 200,
                height: (visibleArea || imageSize).height - 200,
            };
        },
        zoom(factor) {
            this.$refs.cropper.zoom(factor);
        },
        rotate(angle) {
            this.$refs.cropper.rotate(angle);
        },
        flip(x, y) {
            const { image } = this.$refs.cropper.getResult();
            if (image.transforms.rotate % 180 !== 0) {
                this.$refs.cropper.flip(!x, !y);
            } else {
                this.$refs.cropper.flip(x, y);
            }
        },
        closeCopper() {
            this.$emit('closeCopper')
        },
        async isFileValid(file) {
            //check file type
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (
                !this.allowedImageTypes.some(type => file.type.startsWith(type)) &&
                !this.allowedImageExtensions.includes(fileExtension)
            ) {
                this.$toasted.show('Please choose a valid file.');
                return false;
            }

            //check admin
            if (this.isAdministratorGroup) {
                return true;
            }

            //check city profrile creation permission
            if (this.hasCityCreate) {
                if (file.size > 420000000) {
                    let formatMaxSize = this.$helpers.bytesToFormattedSize(420000000)
                    this.$toasted.show(`Exceed the maximum of video upload size. Your current plan has the maximun of the video upload size is ${formatMaxSize}. Please upgrade your plan to get more video upload size.`);
                    this.showLimitationDialog = true;
                    return false;
                } else if (this.storageStats && (this.storageStats.used + file.size > this.storageStats.max)) {
                    this.$toasted.show('The total file storage exceeds the maximum of storage limitation in your current plan. Please upgrade your plan to get more storage.');
                    this.showLimitationDialog = true;
                    return false;
                } else {
                    return true
                }
            }

            //check a single file size
            if (this.allowedImageExtensions.includes(fileExtension)) {
                // handling image file change
                // Maximun file size 25MB
                const maxSize = 25 * 1000 * 1000;
                if (file.size > maxSize) {
                    this.$toasted.show('The maximun of the image size is 25MB.');
                    return false;
                }
            } else {
                if (!this.hasVideoPermission) {
                    this.$toasted.show('Your current plan has no video upload permission.');
                    return false;
                }
                // this.getVideoResolution(file).then((resolution) => {
                //     console.log(`video resolution: ${resolution.width}x${resolution.height}`);
                // });

                // handling video file change
                // Maximun video size
                let formatMaxSize = this.$helpers.bytesToFormattedSize(this.myPlan.storage.max_upload_size)
                if (file.size > this.myPlan.storage.max_upload_size) {
                    this.$toasted.show(`Exceed the maximum of video upload size. Your current plan has the maximum of the video upload size is ${formatMaxSize}.`);
                    this.showLimitationDialog = true;
                    return false;
                }
                // Maximun video duration 1 min
                try {
                    const duration = await this.getVideoDuration(file);
                    if (duration > 60) { // 1 minute
                        this.$toasted.show('The maximum duration of the video is 1 minute.');
                        return false;
                    }
                } catch (error) {
                    this.$toasted.show('Failed to read video metadata.');
                    return false;
                }
            }
            //check total file size
            if (this.storageStats && (this.storageStats.used + file.size > this.storageStats.max)) {
                this.$toasted.show('The total file storage exceeds the maximum storage limitation.');
                this.showLimitationDialog = true;
                return false;
            }

            return true;
        },
        // getVideoResolution(file) {
        //     return new Promise((resolve, reject) => {
        //         let video = document.createElement("video");
        //         video.preload = "metadata";

        //         video.onloadedmetadata = function () {
        //             resolve({ width: video.videoWidth, height: video.videoHeight });
        //         };

        //         video.onerror = function () {
        //             reject("cannot read file");
        //         };

        //         video.src = URL.createObjectURL(file);
        //     });
        // },
        async convertImageFormat(file) {
            if (!file.name.toLowerCase().endsWith('.heic')) {
                return file;
            }

            try {
                const buffer = await file.arrayBuffer();
                return convert({
                    buffer: new Uint8Array(buffer),
                    format: 'JPEG'
                });
            } catch (error) {
                if (error.message.includes("Image is already browser readable")) {
                    return file;
                }
                throw new Error("Fail to convert HEIC file to jpeg file, Please try other file format.");
            }
        },
        async onFileChange(file) {
            this.profilePictureUploading = true;
            if (!file) {
                this.cleanUpCropper();
                this.profilePictureUploading = false;
                return;
            }

            let isFileValid = await this.isFileValid(file);
            if (!isFileValid) {
                this.$refs.fileSelect.$refs.input.value = "";
                this.$refs.fileSelect.reset();
                this.profilePictureUploading = false;
                return;
            }

            if (file.type.startsWith('video/')) {
                this.newFileName = this.$helpers.addTimestampToFileName(file.name);
                this.selectedFile = file;
                this.uploadFile();
            } else {
                try {
                    const convertedFile = await this.convertImageFormat(file);
                    const blob = new Blob([convertedFile], { type: 'image/jpeg' })
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.img = e.target.result;
                        this.originalFileName = file.name;
                    };
                    reader.readAsDataURL(blob);
                } catch (error) {
                    this.$toasted.show(error.message);
                    this.profilePictureUploading = false;
                }
            }

            this.profilePictureUploading = false;
        },
        uploadFile() {
            if (this.img) {
                this.uploadImage()
            } else if (this.selectedFile) {
                this.uploadVideo()
            } else {
                this.$toasted.show("Please select an image or a video")
            }
        },
        uploadImage() {
            if (this.$refs.cropper) {
                const { canvas } = this.$refs.cropper.getResult();
                if (canvas) {
                    canvas.toBlob((blob) => {
                        const fileWithOriginalName = new File([blob], this.originalFileName, { type: blob.type });
                        this.loading = true;
                        let newFileName = this.$helpers.addTimestampToFileName(this.originalFileName)

                        let form = new FormData();
                        form.append(newFileName, fileWithOriginalName);

                        this.$store.dispatch("api/file/uploadMultipleFiles", {
                            request: form,
                        }).then((response) => {
                            if (response.status === 200 && response.data.status === 'SUCCESS') {
                                let uploadFile = {
                                    lastModifiedDate: fileWithOriginalName.lastModified,
                                    size: response.data.files[0].size,
                                    mime_type: response.data.files[0].media_type,
                                    id: response.data.files[0].id,
                                    path: response.data.files[0].path,
                                    url: this.$helpers.getFileUrl(response.data.files[0].path),
                                    name: newFileName,
                                    status: response.data.files[0].status,
                                    quarantined: false,
                                }

                                this.$emit('uploadSuccess', uploadFile, this.lisitngImage);
                                // this.$emit('addFileToDragZone', uploadFile, fileWithOriginalName);
                                this.$emit('closeCopper');
                                this.$toasted.success('Successfully uploaded the file');
                                this.$store.dispatch('api/file/getMetadataStats');
                            } else {
                                response.data.files.forEach(file => {
                                    if (file.status === 'FAILURE') {
                                        this.$toasted.error(`Fail to upload file ${file.name}:${file.message}`);
                                    }
                                });
                            }
                        }).catch(() => {
                            this.$toasted.error('Network error, fail to upload file, please try again later.');
                        }).finally(() => {
                            this.cleanUpCropper()
                            this.loading = false;
                        })
                    }, 'image/jpeg');
                } else {
                    this.$toasted.error('Can’t read this image. Please choose a valid image file.');
                }
            } else {
                this.$toasted.show('Please choose a valid image file.');
            }
        },
        uploadVideo() {
            if (this.selectedFile === null) {
                this.$toasted.show('Please select a file to upload');
                return
            }

            this.$emit('updateUploading', true)
            this.$emit('updateUploadProgress', 0)

            const config = {
                onUploadProgress: progressEvent => {
                    let uploadProgress = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    this.$emit('updateUploadProgress', uploadProgress)
                }
            };

            let form = new FormData();
            form.append(this.newFileName, this.selectedFile);

            this.$store.dispatch('api/file/uploadMultipleFiles', {
                request: form,
                config: config
            }).then((res) => {
                if (res.status === 200 && res.data.status === 'SUCCESS') {
                    let responseFile = {
                        ...res.data.files[0],
                        mime_type: res.data.files[0].media_type,
                    }
                    this.$emit('uploadSuccess', responseFile, this.lisitngImage);
                    this.$emit('closeCopper')
                    this.$toasted.success('Successfully uploaded the file');
                    this.$store.dispatch('api/file/getMetadataStats');
                } else {
                    res.data.files.forEach(file => {
                        if (file.status === 'FAILURE') {
                            this.$toasted.error(`Fail to upload file ${file.name}:${file.message}`);
                        }
                    });
                }
            }).catch(() => {
                this.$toasted.error('Fail to upload video');
            }).finally(() => {
                this.cleanUpCropper()
            });
        },
        openPictureSelectDialog() {
            this.cleanUpCropper()
            this.$refs.fileSelect.$refs.input.click();
        },
        getVideoDuration(file) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                video.preload = 'metadata';
                const url = URL.createObjectURL(file);

                video.onloadedmetadata = () => {
                    URL.revokeObjectURL(url);
                    resolve(video.duration);
                };

                video.onerror = () => {
                    URL.revokeObjectURL(url);
                    reject(new Error('Failed to load video metadata'));
                };
                video.src = url;
            });
        },
        cleanUpCropper() {
            this.originalFileName = null;
            this.img = null;
            this.newFileName = null;
            this.selectedFile = null;
        },
        goPlanSubscription() {
            if (this.isAppliedMerchant) {
                this.$router.replace({ path: '/dashboard/merchant/dashboard' });
            } else {
                this.$router.replace({ path: '/dashboard/plan-subscription' });
            }
        },
        cancelGoPlanSubscription() {
            this.showLimitationDialog = false;
        }
    },
    created() {

    },
    mounted() {
        if (!this.lisitngImage) {
            this.$refs.fileSelect.$refs.input.click();
        } else {
            if (this.lisitngImage instanceof File) {
                this.onFileChange(this.lisitngImage);
            } else {
                this.img = this.lisitngImage.url;
                this.originalFileName = this.lisitngImage.name;
            }
        }
    },

}
</script>

<style scoped>
.custom-file-input {
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    background-color: #0b4073;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
    height: 36px;
    font-size: 16px;
}

.custom-file-input:hover {
    background-color: #0b4073;
}

input[type="file"] {
    display: none;
}
</style>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@import 'node_modules/vuetify/src/styles/settings/variables';
@import "src/globals";

.close-btn {
    position: absolute;
    z-index: 1;
    right: 8px;
    top: 8px;
    color: #cccccc;
    background-color: #cccccc;
    border: solid 0px black;
}

@media only screen and (max-width: map-get($grid-breakpoints, 'sm')) {}
</style>